// extracted by mini-css-extract-plugin
export var block = "icons-module--block--LJHZH";
export var block__short = "icons-module--block__short--uT5-c";
export var checkbox = "icons-module--checkbox--m1X-S";
export var checked = "icons-module--checked--Wr1tD";
export var pinkChecked = "icons-module--pinkChecked--xG30S";
export var plait = "icons-module--plait--AH1VT";
export var redesignPkw = "icons-module--redesignPkw--CtEUd";